/**
 * User 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {USER_QUERY_KEY_MAP} from '../api/user/constant';
import {userFactory} from '../factory/userFactory';

// ============================================
// useAgeAuthQuery
// ============================================

export function useAgeAuthQuery(
  ...args: Parameters<typeof userFactory.ageAuth>
) {
  return useQuery(userFactory.ageAuth(...args));
}

useAgeAuthQuery.getKey = (
  ...args: Parameters<typeof USER_QUERY_KEY_MAP.ageAuth>
) => [...USER_QUERY_KEY_MAP.ageAuth(...args)];
